import { BaseModel } from "@/models/base/BaseModel";
import firebase from "firebase";

export class Document extends BaseModel {
  name: string;
  description: string;
  isEnabled: boolean;
  categories: unknown;
  categoryIds: string[];
  createdByStaffId: string;
  createdByStaffName: string;
  dateTimeCreated: Date | null | firebase.firestore.Timestamp;
  dateTimeUpdated: Date | null | firebase.firestore.Timestamp;
  imageUrl: string;
  thumbnailUrl: string;
  pdfUrl: string;

  constructor(createdByStaffId: string, createdByStaffName: string,) {
    super();
    this.name = "";
    this.description = "";
    this.isEnabled = true;
    this.categories = [];
    this.categoryIds = [];
    this.createdByStaffId = createdByStaffId;
    this.createdByStaffName = createdByStaffName;
    this.dateTimeCreated = firebase.firestore.Timestamp.fromDate(new Date());
    this.dateTimeUpdated = firebase.firestore.Timestamp.fromDate(new Date());
    this.imageUrl = "";
    this.thumbnailUrl = "";
    this.pdfUrl = "";
  }

  clear() {
    this.facilityId = "";
    this.name = "";
    this.description = "";
    this.isEnabled = true;
    this.categories = [];
    this.categoryIds = [];
    this.createdByStaffId = "";
    this.createdByStaffName = "";
    this.dateTimeCreated = null;
    this.dateTimeUpdated = null;
    this.imageUrl = "";
    this.thumbnailUrl = "";
    this.pdfUrl = ""
  }
}